/* eslint-disable camelcase */

export enum QueryListOperandEnum {
  AND = 'AND',
  OR = 'OR',
}

export enum QueryMapOperandEnum {
  NOT = 'NOT',
  EQUAL = 'EQUAL',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  CONTAINS = 'CONTAINS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  RANGE_IN = 'RANGE_IN',
  DAYS_AGO = 'DAYS_AGO',
  UNKNOWN = 'UNKNOWN',
  REGEX = 'REGEX',
  SIMPLE_MATCH = 'SIMPLE_MATCH',
  DROPOFF = 'DROPOFF',
}

export enum QueryKeyEnum {
  user_attributes = 'user_attributes',
  all_page_paths = 'all_page_paths',
  browser = 'browser',
  clicked = 'CLICKED',
  error = 'ERROR',
  country_code = 'country_code',
  created = 'created',
  device = 'device',
  duration = 'duration',
  commented = 'commented',
  referrer = 'referrer',
  first_page_path = 'first_page_path',
  funnel = 'FUNNEL',
  last_page_path = 'last_page_path',
  new_user = 'new_user',
  os = 'os',
  page_count = 'page_count',
  rageclick = 'rageclick',
  javascript_tag_names = 'javascript_tag_names',
  experiments = 'experiments',
  uturn = 'uturn',
  visitor_uuid = 'visitor_uuid',
  nps = 'nps',
  incoming_feedback = 'incoming_feedback',
}

export enum QuerySubKeyEnum {
  text = 'text',
  selector = 'selector',
  page_path = 'page_path',
}

export type UserAttributeQueryKind = 'number' | 'str' | 'email' | 'bool' | 'date' | 'unknown';

export type QueryLeaf = {
  // For key type, we unfortunately have to keep the string for stuff like 'user_attributes.some attribute'
  [key in QueryKeyEnum | string]?: boolean | string | string[] | number | number[];
};

export type QueryListFilter = {
  [key in
    | QueryListOperandEnum
    | QueryKeyEnum.clicked
    | QueryKeyEnum.error
    | QueryKeyEnum.funnel]?: QueryFormatFilter[];
};

export type QueryMapFilter = {
  [key in QueryMapOperandEnum]?: QueryLeaf | QueryFormatFilter;
};

export type QueryFormatFilter = QueryListFilter | QueryMapFilter;
